// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — number-input.styled.classic.js, новая — number-input.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './number-input.styled.classic';
import * as cp from './number-input.styled.cp';

export const Arrows = isCp ? cp.Arrows : classic.Arrows;
export const Content = isCp ? cp.Content : classic.Content;
export const StyledInput = isCp ? cp.StyledInput : classic.StyledInput;
